import { CreditCard } from "lucide-react";
import AppButton from "@/components/AppButtons";
import { SITE } from "@/config/site";

export default function ClientAccess() {
  return (
    <div className="rounded-3xl border border-ink/5 bg-white p-8 shadow-subtle" data-testid="client-access-card">
      <p className="text-xs font-semibold uppercase tracking-[0.18em] text-brand">For Clients</p>
      <h2 className="mt-2 font-cabinet text-2xl font-bold tracking-tight">
        Existing Postings Client?
      </h2>
      <div className="mt-6 grid gap-3">
        <AppButton
          app={SITE.apps.clientManager}
          variant="solid"
          size="lg"
          className="w-full"
          testid="client-access-client-manager"
        />
        <AppButton
          app={SITE.apps.postWage}
          variant="ink"
          size="lg"
          className="w-full"
          testid="client-access-postwage"
        />
      </div>
      <div className="mt-6 rounded-2xl bg-surface p-5">
        <div className="flex items-center gap-3">
          <span className="grid h-11 w-11 shrink-0 place-items-center rounded-xl border border-ink/5 bg-white text-brand">
            <CreditCard className="h-4 w-4" aria-hidden="true" />
          </span>
          <div>
            <p className="text-sm font-bold text-ink">Pay an Invoice</p>
            {SITE.paymentUrl ? (
              <a
                href={SITE.paymentUrl}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="client-access-pay-invoice"
                className="mt-0.5 inline-block text-sm font-semibold text-brand underline underline-offset-2"
              >
                Pay securely online
              </a>
            ) : (
              <p className="mt-0.5 text-xs leading-relaxed text-slate-500">
                Ask us for a secure payment link — call {SITE.phoneDisplay} or mention it in your
                message.
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
